import 'css-chunksrc/client/scenes/task/allocations/allocation/completionCheck/styles.scss';export default {
  "taskCompletionStatus": "_taskCompletionStatus_o4if5_1",
  "late": "_late_o4if5_11",
  "progressed": "_progressed_o4if5_15",
  "completed": "_completed_o4if5_19",
  "disabled": "_disabled_o4if5_36",
  "constrained": "_constrained_o4if5_47"
};